import { render, staticRenderFns } from "./Pagina.vue?vue&type=template&id=063c5541&scoped=true&lang=pug&"
import script from "./Pagina.vue?vue&type=script&lang=js&"
export * from "./Pagina.vue?vue&type=script&lang=js&"
import style0 from "./Pagina.styl?vue&type=style&index=0&id=063c5541&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c5541",
  null
  
)

export default component.exports